var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAppStore215X64(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 135 40",
    width: 215,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M130.2,40H4.73A4.74,4.74,0,0,1,0,35.27V4.73A4.73,4.73,0,0,1,4.73,0H130.2A4.8,4.8,0,0,1,135,4.73V35.27A4.8,4.8,0,0,1,130.2,40Z",
    style: {
      fill: "#a6a6a6"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M134,35.27a3.83,3.83,0,0,1-3.83,3.83H4.73A3.83,3.83,0,0,1,.89,35.27V4.73A3.84,3.84,0,0,1,4.73.89H130.2A3.83,3.83,0,0,1,134,4.73V35.27Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M30.13,19.78a5.8,5.8,0,0,1,2.76-4.86,5.93,5.93,0,0,0-4.68-2.53c-2-.21-3.87,1.18-4.88,1.18s-2.57-1.16-4.23-1.12a6.23,6.23,0,0,0-5.24,3.2c-2.27,3.92-.58,9.69,1.59,12.86,1.09,1.55,2.35,3.29,4,3.23s2.23-1,4.19-1,2.51,1,4.21,1,2.84-1.56,3.89-3.13a12.84,12.84,0,0,0,1.78-3.62A5.6,5.6,0,0,1,30.13,19.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.93,10.31a5.71,5.71,0,0,0,1.31-4.09,5.81,5.81,0,0,0-3.76,1.94,5.43,5.43,0,0,0-1.34,3.94A4.8,4.8,0,0,0,26.93,10.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.65,31.5H51.37l-1.24-3.91H45.81L44.62,31.5H42.41L46.69,18.2h2.65ZM49.76,26l-1.13-3.47Q48.45,21.95,48,20h0q-.2.85-.63,2.51L46.18,26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.66,26.59a5.45,5.45,0,0,1-1.32,3.87,3.87,3.87,0,0,1-2.94,1.26,2.94,2.94,0,0,1-2.72-1.36h0v5.05H55.5V25.07q0-1.54-.08-3.16H57.3l.12,1.52h0a3.79,3.79,0,0,1,6.07-.38A5.29,5.29,0,0,1,64.66,26.59Zm-2.17.08a4,4,0,0,0-.63-2.31A2.18,2.18,0,0,0,60,23.41a2.21,2.21,0,0,0-1.43.52,2.43,2.43,0,0,0-.84,1.37,2.79,2.79,0,0,0-.1.65v1.6a2.56,2.56,0,0,0,.64,1.77,2.13,2.13,0,0,0,1.67.72,2.18,2.18,0,0,0,1.88-.93A4.09,4.09,0,0,0,62.49,26.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7,26.59a5.45,5.45,0,0,1-1.32,3.87,3.86,3.86,0,0,1-2.94,1.26,2.94,2.94,0,0,1-2.72-1.36h0v5.05H66.54V25.07q0-1.54-.08-3.16h1.88l.12,1.52h0a3.79,3.79,0,0,1,6.07-.38A5.3,5.3,0,0,1,75.7,26.59Zm-2.17.08a4,4,0,0,0-.63-2.31A2.18,2.18,0,0,0,71,23.41a2.21,2.21,0,0,0-1.43.52,2.43,2.43,0,0,0-.84,1.37,2.82,2.82,0,0,0-.1.65v1.6a2.57,2.57,0,0,0,.64,1.77A2.13,2.13,0,0,0,71,30a2.18,2.18,0,0,0,1.87-.93A4.09,4.09,0,0,0,73.53,26.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88,27.77a3.55,3.55,0,0,1-1.18,2.76,5.24,5.24,0,0,1-3.62,1.17,6.35,6.35,0,0,1-3.45-.83l.49-1.78a5.84,5.84,0,0,0,3.08.85,2.91,2.91,0,0,0,1.88-.54,1.78,1.78,0,0,0,.67-1.45,1.85,1.85,0,0,0-.55-1.36,5.15,5.15,0,0,0-1.84-1Q80,24.25,80,21.74A3.38,3.38,0,0,1,81.25,19a4.83,4.83,0,0,1,3.26-1,6.46,6.46,0,0,1,3,.63L87,20.37a5.24,5.24,0,0,0-2.55-.61,2.57,2.57,0,0,0-1.76.55,1.58,1.58,0,0,0-.53,1.2,1.62,1.62,0,0,0,.61,1.3,6.91,6.91,0,0,0,1.94,1,6.57,6.57,0,0,1,2.53,1.62A3.39,3.39,0,0,1,88,27.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.09,23.51H92.74v4.66q0,1.78,1.24,1.78a3.83,3.83,0,0,0,.95-.1L95,31.46a4.82,4.82,0,0,1-1.66.24,2.56,2.56,0,0,1-2-.77,3.78,3.78,0,0,1-.71-2.59V23.51h-1.4v-1.6h1.4V20.15l2.09-.63v2.39h2.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.69,26.63a5.27,5.27,0,0,1-1.26,3.63,4.51,4.51,0,0,1-3.52,1.46,4.29,4.29,0,0,1-3.37-1.4,5.1,5.1,0,0,1-1.25-3.53,5.21,5.21,0,0,1,1.29-3.65,4.48,4.48,0,0,1,3.48-1.42,4.38,4.38,0,0,1,3.4,1.4A5.06,5.06,0,0,1,105.69,26.63Zm-2.21.07a4.32,4.32,0,0,0-.57-2.28A2.11,2.11,0,0,0,101,23.27a2.14,2.14,0,0,0-2,1.15,4.4,4.4,0,0,0-.57,2.32A4.32,4.32,0,0,0,99,29a2.18,2.18,0,0,0,3.85,0A4.32,4.32,0,0,0,103.48,26.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.62,23.78a3.69,3.69,0,0,0-.67-.06,2,2,0,0,0-1.74.85,3.19,3.19,0,0,0-.53,1.89v5h-2.13l0-6.57q0-1.66-.08-3h1.86l.08,1.84h.06a3.28,3.28,0,0,1,1.07-1.52,2.58,2.58,0,0,1,1.54-.51,3.38,3.38,0,0,1,.53,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.16,26.25a5,5,0,0,1-.08,1h-6.4a2.79,2.79,0,0,0,.93,2.17,3.17,3.17,0,0,0,2.09.67,7.08,7.08,0,0,0,2.59-.45l.33,1.48a8,8,0,0,1-3.22.59,4.66,4.66,0,0,1-3.51-1.31,4.85,4.85,0,0,1-1.27-3.52,5.5,5.5,0,0,1,1.19-3.61,4.09,4.09,0,0,1,3.36-1.54,3.57,3.57,0,0,1,3.14,1.54A5.19,5.19,0,0,1,122.16,26.25Zm-2-.55a2.9,2.9,0,0,0-.41-1.64,1.86,1.86,0,0,0-1.7-.89,2,2,0,0,0-1.7.87,3.17,3.17,0,0,0-.63,1.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.05,10A3.28,3.28,0,0,1,48,12.67a4.21,4.21,0,0,1-2.78.82,13,13,0,0,1-1.53-.08V7a11.28,11.28,0,0,1,1.8-.14,3.89,3.89,0,0,1,2.59.75A3,3,0,0,1,49.05,10Zm-1.11,0a2.39,2.39,0,0,0-.61-1.76,2.39,2.39,0,0,0-1.77-.61,4.47,4.47,0,0,0-.84.07v4.89a5.6,5.6,0,0,0,.71,0A2.48,2.48,0,0,0,47.29,12,2.68,2.68,0,0,0,47.94,10Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.91,11a2.58,2.58,0,0,1-.62,1.78,2.22,2.22,0,0,1-1.73.72,2.11,2.11,0,0,1-1.65-.69,2.51,2.51,0,0,1-.62-1.74,2.56,2.56,0,0,1,.63-1.79,2.2,2.2,0,0,1,1.71-.7,2.16,2.16,0,0,1,1.67.69A2.49,2.49,0,0,1,54.91,11Zm-1.09,0A2.13,2.13,0,0,0,53.54,10a1,1,0,0,0-.94-.56,1.05,1.05,0,0,0-1,.56,2.17,2.17,0,0,0-.28,1.14,2.13,2.13,0,0,0,.28,1.12,1.07,1.07,0,0,0,1.89,0A2.12,2.12,0,0,0,53.82,11.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.77,8.72l-1.47,4.71h-1l-.61-2a15.14,15.14,0,0,1-.38-1.52h0a11.1,11.1,0,0,1-.38,1.52l-.65,2h-1L55.94,8.72H57L57.55,11q.19.8.32,1.51h0q.12-.59.39-1.5l.67-2.25h.85l.64,2.2q.23.8.38,1.55h0a14.75,14.75,0,0,1,.32-1.55l.57-2.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2,13.43h-1v-2.7q0-1.25-1-1.25a1,1,0,0,0-.76.34,1.21,1.21,0,0,0-.29.81v2.8h-1V10.07q0-.62,0-1.35H65l0,.74h0a1.51,1.51,0,0,1,.54-.57,1.77,1.77,0,0,1,1-.26,1.5,1.5,0,0,1,1.1.43,2.07,2.07,0,0,1,.54,1.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.09,13.43H70V6.56h1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.26,11a2.58,2.58,0,0,1-.62,1.78,2.22,2.22,0,0,1-1.73.72,2.11,2.11,0,0,1-1.65-.69,2.51,2.51,0,0,1-.62-1.74,2.56,2.56,0,0,1,.63-1.79A2.2,2.2,0,0,1,75,8.62a2.16,2.16,0,0,1,1.67.69A2.49,2.49,0,0,1,77.26,11Zm-1.09,0A2.13,2.13,0,0,0,75.89,10a1,1,0,0,0-.94-.56A1,1,0,0,0,74,10a2.17,2.17,0,0,0-.28,1.14A2.13,2.13,0,0,0,74,12.21a1.06,1.06,0,0,0,1,.56,1,1,0,0,0,.94-.57A2.11,2.11,0,0,0,76.17,11.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.33,13.43h-.94l-.08-.54h0a1.61,1.61,0,0,1-1.38.65,1.42,1.42,0,0,1-1.08-.43,1.34,1.34,0,0,1-.37-1,1.47,1.47,0,0,1,.72-1.32,3.76,3.76,0,0,1,2-.45V10.3q0-.93-1-.93A2.19,2.19,0,0,0,79,9.72L78.79,9a3,3,0,0,1,1.62-.41q1.85,0,1.85,1.95v1.74A7.37,7.37,0,0,0,82.33,13.43Zm-1.09-1.62v-.73q-1.73,0-1.73,1a.71.71,0,0,0,.2.55.73.73,0,0,0,.51.18,1.05,1.05,0,0,0,.64-.22.89.89,0,0,0,.36-.56A.85.85,0,0,0,81.24,11.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.29,13.43h-.93l0-.76h0a1.57,1.57,0,0,1-1.51.86,1.77,1.77,0,0,1-1.42-.67,2.61,2.61,0,0,1-.56-1.74,2.73,2.73,0,0,1,.61-1.85,1.88,1.88,0,0,1,1.46-.66,1.41,1.41,0,0,1,1.33.64h0V6.56h1v5.61Q88.25,12.85,88.29,13.43Zm-1.09-2v-.79a1.5,1.5,0,0,0,0-.33,1.19,1.19,0,0,0-.38-.64,1,1,0,0,0-.7-.26,1.08,1.08,0,0,0-.92.47,2,2,0,0,0-.34,1.19,1.86,1.86,0,0,0,.32,1.14,1.08,1.08,0,0,0,.92.47,1,1,0,0,0,.83-.39A1.3,1.3,0,0,0,87.2,11.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.25,11a2.58,2.58,0,0,1-.62,1.78,2.21,2.21,0,0,1-1.73.72,2.11,2.11,0,0,1-1.65-.69,2.51,2.51,0,0,1-.62-1.74,2.56,2.56,0,0,1,.63-1.79A2.2,2.2,0,0,1,95,8.62a2.15,2.15,0,0,1,1.67.69A2.49,2.49,0,0,1,97.25,11Zm-1.09,0A2.13,2.13,0,0,0,95.88,10a1,1,0,0,0-.94-.56A1.05,1.05,0,0,0,94,10a2.17,2.17,0,0,0-.28,1.14A2.13,2.13,0,0,0,94,12.21a1.07,1.07,0,0,0,1.89,0A2.13,2.13,0,0,0,96.16,11.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.88,13.43h-1v-2.7q0-1.25-1-1.25a.94.94,0,0,0-.76.34,1.21,1.21,0,0,0-.29.81v2.8h-1V10.07q0-.62,0-1.35h.92l0,.74h0a1.53,1.53,0,0,1,.54-.57,1.77,1.77,0,0,1,1-.26,1.5,1.5,0,0,1,1.1.43,2.07,2.07,0,0,1,.54,1.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.94,9.5h-1.15v2.29c0,.58.2.87.61.87a1.86,1.86,0,0,0,.47,0l0,.8a2.36,2.36,0,0,1-.81.12,1.25,1.25,0,0,1-1-.38,1.85,1.85,0,0,1-.35-1.27V9.5h-.69V8.72h.69V7.86l1-.31V8.72h1.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.48,13.43h-1V10.75q0-1.27-.95-1.27a1,1,0,0,0-1,.74,1.31,1.31,0,0,0,0,.38v2.83h-1V6.56h1V9.4h0a1.58,1.58,0,0,1,1.42-.77A1.46,1.46,0,0,1,115,9a2.15,2.15,0,0,1,.53,1.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.21,10.85a2.51,2.51,0,0,1,0,.48H118a1.37,1.37,0,0,0,.46,1.07,1.56,1.56,0,0,0,1,.33,3.48,3.48,0,0,0,1.27-.22l.16.73a4,4,0,0,1-1.58.29,2.28,2.28,0,0,1-1.72-.64,2.38,2.38,0,0,1-.62-1.73,2.7,2.7,0,0,1,.58-1.78,2,2,0,0,1,1.65-.76,1.75,1.75,0,0,1,1.54.76A2.53,2.53,0,0,1,121.21,10.85Zm-1-.27a1.41,1.41,0,0,0-.2-.81.91.91,0,0,0-.83-.44,1,1,0,0,0-.83.43,1.58,1.58,0,0,0-.31.81Z",
    style: {
      fill: "#fff"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStore215X64);
export default __webpack_public_path__ + "static/media/app-store_215x64.fa25f9bc3934bea379bb20cb9e7defdb.svg";
export { ForwardRef as ReactComponent };